import React from "react";
import { useLocation } from "react-router-dom";
import CalculusModuleSubtopic from "../CalculusModuleSubtopic";

const VectorDifferentiation = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <CalculusModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Vector Differentiation"
      videos={[
        "https://www.youtube.com/embed/MRbZ3gGM7vM?list=PLhSp9OSVmeyIeKw3AdI2e3R9Q2IKzPcy7",
        "https://www.youtube.com/embed/1i6zNMB9e5I?list=PLhSp9OSVmeyIeKw3AdI2e3R9Q2IKzPcy7"
      ]}
      takeaways={[]}
      questions={[]}
      exampleVideos={[]}
    />
  );
}

export default VectorDifferentiation;
